module.exports = __webpack_public_path__ + "static/amtrust-logo-ca43e09e4a03ef00b02bb7854479e23e.png";